import invariant from 'invariant';

import type { ApiRemoteOptions } from '#/api/types/ApiRemoteOptions';
import type { I18nFn } from '#/i18n/types/I18nFn';
import { getCountryName, getUsStateName } from '#/utils/internationalization';

import { getCityStateString } from './getCityStateString';

type Args = {
  i18n: I18nFn;
  remoteOptions: Omit<ApiRemoteOptions, 'locationType'>;
  address: {
    city: string;
    stateCode: string;
    country: string;
  };
};

export const getWorkLocationString = ({
  i18n,
  remoteOptions: { remoteZone, remoteCountry, remoteState },
  address: { city, stateCode, country },
}: Args) => {
  if (remoteZone === 'WORLD') {
    return i18n('Anywhere');
  }

  if (remoteZone === 'COUNTRY') {
    invariant(remoteCountry, 'Undefined remoteCountry');
    return getCountryName(i18n, remoteCountry);
  }

  if (remoteZone === 'STATE') {
    invariant(remoteState, 'Undefined remoteState');
    invariant(remoteCountry, 'Undefined remoteCountry');
    return i18n('%(state)s, %(country)s', {
      state: getUsStateName(i18n, remoteState),
      country: remoteCountry,
    });
  }

  return getCityStateString(i18n, { city, stateCode, country });
};
